<template>
  <v-row align="center" justify="center">
    <v-col class="text-center" cols="12">
      <v-avatar size="100">
        <v-img src="@/assets/profile-pic.jpeg" alt="My Profile Picture" />
      </v-avatar>

      <br />

      <h1 class="display-3 font-weight-thin mb-4">Aviel Yosef</h1>
      <h3 class="display-1 font-weight-thin mb-3">Software Engineer</h3>

      <br />

      <v-row align="center" justify="center">
        <div v-for="item in items" :key="item.title">
          <v-btn outlined color="white" class="ma-2 white--text" :href="item.url" target="_blank">
            <v-icon left dark>{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-btn>
        </div>
        <v-btn outlined color="white" class="ma-2 white--text" href="/Aviel-Yosef-CV.pdf" target="_blank">
          <v-icon left dark>mdi-cloud-download</v-icon>Download CV
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: "Github",
          icon: "mdi-github",
          url: "https://github.com/Avielyo10"
        },
        {
          title: "Linkedin",
          icon: "mdi-linkedin",
          url: "https://www.linkedin.com/in/avielyosef"
        }
      ]
    };
  },
  name: "Welcome"
};
</script>
  